import { z, ZodObject, ZodRawShape, ZodType } from 'zod';

export type Paginated<T> = {
	total: number;
	rows: T[];
};

export const createPaginatedSchema = <TRow, TAdditionalData = unknown>(
	scheme: ZodType<TRow>,
	additionalData?: ZodType<TAdditionalData>,
): ZodType<Paginated<TRow> & TAdditionalData> =>
	z
		.object({
			total: z.number(),
			rows: z.array(scheme),
		})
		.merge(
			(additionalData as ZodType<TAdditionalData> & ZodObject<ZodRawShape>) || z.object({}),
		) as unknown as ZodType<Paginated<TRow> & TAdditionalData>;
